import React from "react";

function DiscountIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 133"
      width="160"
      height="133"
      opacity="0.7"
    >
      {/* Background circle */}
      <circle cx="80" cy="67" r="40" fill="#F5F7F9" />

      {/* Back coupon */}
      <g transform="translate(43, 43)">
        {/* Shadow */}
        <rect
          x="1.3"
          y="1.3"
          width="73"
          height="47"
          rx="4"
          fill="#0677ff"
          opacity="0.2"
        />
        {/* Main coupon */}
        <rect x="0" y="0" width="73" height="47" rx="4" fill="#0063ff" />
        {/* Dotted line */}
        <path
          d="M37 5 L37 41"
          stroke="#F5F7F9"
          strokeWidth="1.3"
          strokeDasharray="3 3"
        />

        {/* Percentage symbol */}
        <g transform="translate(8, 15)">
          {/* Top circle */}
          <circle
            cx="7"
            cy="4"
            r="2"
            fill="none"
            stroke="#F5F7F9"
            strokeWidth="2"
          />
          {/* Bottom circle */}
          <circle
            cx="17"
            cy="16"
            r="2"
            fill="none"
            stroke="#F5F7F9"
            strokeWidth="2"
          />
          {/* Diagonal line */}
          <line
            x1="5"
            y1="16"
            x2="19"
            y2="4"
            stroke="#F5F7F9"
            strokeWidth="2"
          />
        </g>

        {/* Content lines */}
        <rect
          x="47"
          y="13"
          width="20"
          height="3"
          rx="1.5"
          fill="#F5F7F9"
          opacity="0.5"
        />
        <rect
          x="47"
          y="20"
          width="13"
          height="3"
          rx="1.5"
          fill="#F5F7F9"
          opacity="0.5"
        />
      </g>

      {/* Small floating price tag */}
      <g transform="translate(107, 50)">
        <path
          d="M0 0 L12 0 L12 16 L0 16 Q-4 8 0 0"
          fill="#0063ff"
          opacity="0.5"
        />
        <circle cx="6" cy="8" r="1.7" fill="#F5F7F9" />
      </g>
    </svg>
  );
};

export default DiscountIcon;
